module.exports = __webpack_public_path__ + "static/media/refrigeratorWrong.5deb45b0.png";